import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { FaGoogle, FaGithub } from "react-icons/fa";
import { useApp } from "../context/AppContext";

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useApp();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      const success = login(email, password);
      setLoading(false);
      if (success) navigate("/dashboard");
    }, 800);
  };

  return (
    <div className="auth-card fade-in-up">
      <div className="auth-header">
        <h2>Welcome Back</h2>
        <p>Sign in to your account to continue</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Email Address</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0" style={{ borderRadius: "10px 0 0 10px", border: "2px solid var(--gray-200)" }}>
              <FiMail className="text-muted" />
            </span>
            <input
              className="form-control border-start-0"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ borderRadius: "0 10px 10px 0", border: "2px solid var(--gray-200)", borderLeft: "none" }}
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0" style={{ borderRadius: "10px 0 0 10px", border: "2px solid var(--gray-200)" }}>
              <FiLock className="text-muted" />
            </span>
            <input
              className="form-control border-start-0 border-end-0"
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ border: "2px solid var(--gray-200)", borderLeft: "none", borderRight: "none" }}
            />
            <button
              type="button"
              className="input-group-text bg-white border-start-0"
              onClick={() => setShowPassword(!showPassword)}
              style={{ borderRadius: "0 10px 10px 0", border: "2px solid var(--gray-200)", borderLeft: "none", cursor: "pointer" }}
            >
              {showPassword ? <FiEyeOff className="text-muted" /> : <FiEye className="text-muted" />}
            </button>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="form-check">
            <input className="form-check-input" type="checkbox" id="remember" />
            <label className="form-check-label small text-muted" htmlFor="remember">
              Remember me
            </label>
          </div>
          <a href="#!" className="small text-decoration-none" style={{ color: "var(--primary)" }}>
            Forgot password?
          </a>
        </div>

        <button className="btn btn-auth" type="submit" disabled={loading}>
          {loading ? (
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          ) : null}
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>

      <div className="divider">or continue with</div>

      <div className="d-flex gap-2">
        <button className="social-btn">
          <FaGoogle style={{ color: "#ea4335" }} /> Google
        </button>
        <button className="social-btn">
          <FaGithub /> GitHub
        </button>
      </div>

      <p className="text-center mt-3 mb-0 small text-muted">
        Don't have an account?{" "}
        <Link to="/sign-up" className="text-decoration-none fw-semibold" style={{ color: "var(--primary)" }}>
          Sign up
        </Link>
      </p>
    </div>
  );
}
